import React from "react";
import "../ConfirmBox/style.scss";
import {useTranslation} from "react-i18next";
import BlockBtn from "../BlockBtn";
import errorImage from "../../images/icons/error.png";
import crossImage from "../../images/icons/cross.png";

const ErrorModal = ({text, performAction, close}) => {
  const {t} = useTranslation();
  return (
    <div className="confirm-box-container">
      <div className="confirm-box-inner-container">
        <div className={"confirm-box-title-div"}>
          <img
            className="grey-close-image"
            src={crossImage}
            alt="X"
            onClick={close}
          />
        </div>
        <img className="modal-image" src={errorImage} alt="error" />
        <div className="confirm-box-text-container error-modal-message">
          <label className="confirm-box-text">{text}</label>
        </div>
        <div className="confirm-box-button-div error-btn-wrap">
          <BlockBtn
            name={t("cancel.shift.title")}
            handleClick={performAction}
            disabled={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
